import { useDispatch } from 'react-redux';

// Types
import { AppDispatch } from 'types/RootState.types';

// Config
import paymentTypeConstants from '@constants/paymentTypeConstants';
import { applePayExpress } from '@redux/actions/payment/applePayActions';
import { setSelectedPaymentType, triggerPlaceOrderAndPayStartAnalytics } from '@redux/actions/payment/paymentActions';

// Components
import ApplePayButton from '@components/add-payment-details/apple-pay-button/ApplePayButton';

const ApplePayExpress = () => {
  const dispatch: AppDispatch = useDispatch();

  const onClick = async () => {
    dispatch(triggerPlaceOrderAndPayStartAnalytics('applepayExpress'));
    await dispatch(setSelectedPaymentType({ paymentType: paymentTypeConstants.APPLE_PAY_EXPRESS }));

    dispatch(applePayExpress());
  };

  return <ApplePayButton isExpress onClick={onClick} />;
};

export default ApplePayExpress;
